export default "__VITE_PUBLIC_ASSET__17aa1627__"